import React from 'react';
import PropTypes from 'prop-types';
import { Box, TextField, MenuItem, IconButton } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import useThemeStyles from '../../../hooks/useThemeStyles';

const RELATION_TYPES = [
  { value: 'one-one', label: '1 : 1' },
  { value: 'one-many', label: '1 : N' },
  { value: 'many-many', label: 'N : N' },
];

/**
 * Dumb relation editor row: from / type / to / label.
 */
const RelationRow = ({ relation, entities, onChange, onDelete }) => {
  const { colors } = useThemeStyles();

  const selectSx = {
    '& .MuiSelect-select': { color: colors.text.primary },
    '& .MuiOutlinedInput-root': {
      '& fieldset': { borderColor: colors.border.subtle },
      '&:hover fieldset': { borderColor: colors.interactive.primary },
    },
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
      <TextField
        select
        size="small"
        value={relation.from}
        onChange={(e) => onChange({ ...relation, from: e.target.value })}
        sx={{ ...selectSx, minWidth: 130 }}
      >
        {entities.map((entity) => (
          <MenuItem key={entity.id} value={entity.id}>
            {entity.name || 'Untitled'}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        size="small"
        value={relation.type}
        onChange={(e) => onChange({ ...relation, type: e.target.value })}
        sx={{ ...selectSx, width: 90 }}
      >
        {RELATION_TYPES.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        size="small"
        value={relation.to}
        onChange={(e) => onChange({ ...relation, to: e.target.value })}
        sx={{ ...selectSx, minWidth: 130 }}
      >
        {entities.map((entity) => (
          <MenuItem key={entity.id} value={entity.id}>
            {entity.name || 'Untitled'}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        size="small"
        placeholder="label (e.g. owns)"
        value={relation.label || ''}
        onChange={(e) => onChange({ ...relation, label: e.target.value })}
        sx={{
          flex: 1,
          minWidth: 120,
          input: { color: colors.text.primary },
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: colors.border.subtle },
          },
        }}
      />
      <IconButton size="small" onClick={onDelete} sx={{ color: colors.icon.secondary }}>
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

RelationRow.propTypes = {
  relation: PropTypes.shape({
    id: PropTypes.string.isRequired,
    from: PropTypes.string,
    to: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  entities: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }))
    .isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default RelationRow;
